import { FlexRow } from '@fox/layout/src/flex';
import { useMediaQuery } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import styled from 'styled-components';
import { ResponsiveTableContextProvider, useResponsiveTableContext } from './context';
import { ResponsiveTablePaginationProps, ResponsiveTableProps } from './contracts';
import { DeskTopView } from './desktop-view';
import { MobileView } from './mobile-view';

const TableWrapper = styled.div`
	width: 100%;
`;

function ResponsiveTablePagination({ paginationProps }: { paginationProps: ResponsiveTablePaginationProps }) {
	const { itemsPerPage = 10, onPageChange, total, page } = paginationProps;
	const { clearRowSelection } = useResponsiveTableContext();

	return total <= itemsPerPage ? null : (
		<Pagination
			style={{ alignSelf: 'center' }}
			count={Math.ceil(total / itemsPerPage)}
			page={page}
			onChange={(_, value) => {
				onPageChange(value);
				clearRowSelection();
			}}
			color={'secondary'}
		/>
	);
}

export function ResponsiveTable<T>({
	data,
	columns,
	paginationProps,
	sortProps,
	rowActionComponent,
	mobileRowActionComponent,
	loading,
	rowIdentifier,
	selectedRowActionComponent,
	rowShowSelectorEvaluatorFunction,
	rowsExpandedOnSmallScreens,
	disableTooltips
}: ResponsiveTableProps<T>) {
	const isMobile = useMediaQuery('(max-width: 800px)');
	return (
		<ResponsiveTableContextProvider
			data={data}
			columns={columns}
			sortProps={sortProps}
			rowActionComponent={rowActionComponent}
			mobileRowActionComponent={mobileRowActionComponent}
			selectedRowActionComponent={selectedRowActionComponent}
			loading={loading}
			rowIdentifier={rowIdentifier}
			rowShowSelectorEvaluatorFunction={rowShowSelectorEvaluatorFunction}
			rowsExpandedOnSmallScreens={rowsExpandedOnSmallScreens}
			disableTooltips={disableTooltips}
		>
			{isMobile ? (
				<MobileView />
			) : (
				<TableWrapper>
					<DeskTopView />
				</TableWrapper>
			)}
			{paginationProps ? (
				<FlexRow style={{ justifyContent: 'center', marginTop: '1rem' }}>
					<ResponsiveTablePagination paginationProps={paginationProps} />
				</FlexRow>
			) : null}
		</ResponsiveTableContextProvider>
	);
}
